const convertCommaToDot = (string) => {
  return string.replace(",", ".");
};

export default convertCommaToDot;
